import {

    TODOS_REQUEST,
    TODOS_SUCCESS,
    TODOS_FAIL,

    ADD_TODO_REQUEST,
    ADD_TODO_SUCCESS,
    ADD_TODO_FAIL,

    EDIT_TODO_REQUEST,
    EDIT_TODO_SUCCESS,
    EDIT_TODO_FAIL,

    DELETE_TODO_REQUEST,
    DELETE_TODO_SUCCESS,
    DELETE_TODO_FAIL,

} from '../constants/dataConstants'

import { axiosAuthed } from "../auth/createAuthedAxios.ts";

export const getTodos = () => async (dispatch, getState) => {


   
    try {
        dispatch({
            type: TODOS_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}todos/`

        const { data } = await axiosAuthed.get(

            url,
            config
        )


        dispatch({
            type: TODOS_SUCCESS,
            payload: data
        })



    } catch (error) {
        dispatch({
            type: TODOS_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}


export const addTodo = (todo) => async (dispatch, getState) => {


    try {
        dispatch({
            type: ADD_TODO_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}todos/todo`

        const { data } = await axiosAuthed.post(

            url,
            todo,
            config
        )


        dispatch({
            type: ADD_TODO_SUCCESS,
            payload: data
        })
        dispatch(getTodos())



    } catch (error) {
        dispatch({
            type: ADD_TODO_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}


export const editTodo = (todo) => async (dispatch, getState) => {


    try {
        dispatch({
            type: EDIT_TODO_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}todos/todo/${todo.id}`

        const { data } = await axiosAuthed.put(

            url,
            todo,
            config
        )


        dispatch({
            type: EDIT_TODO_SUCCESS,
            payload: data
        })
        dispatch(getTodos())



    } catch (error) {
        dispatch({
            type: EDIT_TODO_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}


export const deleteTodo = (id) => async (dispatch, getState) => {


    try {
        dispatch({
            type: DELETE_TODO_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const url = `${process.env.REACT_APP_HOST_IP}todos/todo/${id}`

        const { data } = await axiosAuthed.delete(

            url,
            config
        )


        dispatch({
            type: DELETE_TODO_SUCCESS,
            payload: data
        })
        dispatch(getTodos())



    } catch (error) {
        dispatch({
            type: DELETE_TODO_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

